import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useCustomParams } from "../../../hooks/useCustomParams";
import CustomTable from "../../../components/Table/CustomTable";
import { useJobs } from "../../../reactQuery/job";
import Loader from "../../../components/Loader";
import { columns } from "./tableColumns";
import { setTickets } from "../../../redux/ticketAssignSlice";
import AssignButton from "./AssignButton";

function Table() {
  const dispatch = useDispatch();
  const [inspector] = useCustomParams("inspector");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [date] = useCustomParams("date");
  const encryptDate = JSON.parse(date);

  const { isLoading, error, responseData, isError, refetch, totalRecords } =
    useJobs({
      page: 1,
      pageSize: 10,
      date: encryptDate,
      pagination: false,
      inspector,
    });

  useEffect(() => {
    refetch();
  }, [date, inspector]);
  useEffect(() => {
    dispatch(
      setTickets(
        responseData?.map((el) => {
          return {
            job_id: el.job_id,
            inspector_id: el.inspector_id,
          };
        }) || []
      )
    );
  }, [responseData]);
  return (
    <div className="assign-inspector-table">
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>{error?.response?.data?.message || "Error"}</p>
        </div>
      )}
      {!isLoading && !isError && (
        <CustomTable
          initialRows={responseData}
          columns={columns}
          defaultSort={"job_id"}
          headerBgColor={"#F5F5F9"}
          rowCount={totalRecords}
          setPaginationModel={(data) => {
            setPage(data.page);
            setPageSize(data.pageSize);
          }}
          page={page}
          pageSize={pageSize}
          subHeight={324}
          hideFooter={true}
        />
      )}
      <AssignButton />
    </div>
  );
}

export default Table;
